import React from 'react'
import './thedemo.css'

const Thedemo = () => {
  return (
    <div className="demo">
        <hr />
        <div className="medisync__thedemo">
            <h1>Demo Video</h1>
            <iframe src="https://youtu.be/FExp9YuTzbY" title="Demo Video" allowFullScreen></iframe>
        </div>
    </div>
  )
}

export default Thedemo